import {
    GET_PURCHASE_ORDER_HISTORY_REPORT_PROGRESS, GET_PURCHASE_ORDER_HISTORY_REPORT_SUCCESS, GET_PURCHASE_ORDER_HISTORY_REPORT_FAILURE,

    RESET_MESSAGE,

} from '../../types/actionTypes';

const initialState = {
    purchaseOrderHistory: [],
    loginUser: null,
    error: false,
    loading: false,
    message: null
}

const purchase_order_history_report_reducer = (state = initialState, action) => {
    switch (action.type) {
        case GET_PURCHASE_ORDER_HISTORY_REPORT_SUCCESS:
            return { ...state, purchaseOrderHistory: action.purchaseOrderHistory, loading: false };
        case GET_PURCHASE_ORDER_HISTORY_REPORT_FAILURE:
            return { ...state, loading: false, error: true };
        case GET_PURCHASE_ORDER_HISTORY_REPORT_PROGRESS:
            return { ...state, loading: true, error: false };
        case RESET_MESSAGE:
            return { ...state, message: null }; // Reset the edit message

        default:
            return state
    }
}

export default purchase_order_history_report_reducer;